import type { ButtonProps } from '@mantine/core';

import classes from './IncidentActionButton.module.css';

export type IncidentActionButtonVariant = 'default' | 'compactOutline';

export const compactIncidentActionButtonClassNames: ButtonProps['classNames'] = {
  root: classes.root,
  inner: classes.inner,
  label: classes.label,
  section: classes.section,
};
